import { QueryParams } from '@shared/models/query.models';
import { Observable } from 'rxjs';

export abstract class DataTableSourceService<T> {
  abstract getDataTable(query: QueryParams): Observable<T>;
}
